// extracted by mini-css-extract-plugin
module.exports = {"heading":"record_heading_3GoZQ","description":"record_description_1uss0","list":"record_list_LzkoD"};